import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { BannerItem } from '@src/app/core/models/cms/banner-item.model';

export interface CreateBannerItemDto {
  bannerId: number;
  order: number;
  imageFileId: number;
  imageAltText: string | null;
  urlLink: string | null;
  openNewTab: boolean;
  isActive: boolean;
  startDate: string | null;
  endDate: string | null;
}

/** Body para PUT /internal-api/banneritem */
export interface UpdateBannerItemDto {
  id: number;
  bannerId: number;
  order: number;
  urlLink: string | null;
  imageFileId: number;
  imageUrl: string | null;
  imageAltText: string | null;
  openNewTab: boolean;
  isActive: boolean;
  startDate: string;
  endDate: string;
}

@Injectable({ providedIn: 'root' })
export class BannerItemService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/banneritem`;

  /** GET /internal-api/banneritem?bannerId={bannerId} */
  getByBannerId(bannerId: number): Observable<BannerItem[]> {
    return this.http.get<BannerItem[]>(this.apiUrl, {
      params: { bannerId: bannerId.toString() },
    });
  }

  /** POST /internal-api/banneritem */
  create(body: CreateBannerItemDto): Observable<BannerItem> {
    return this.http.post<BannerItem>(this.apiUrl, body);
  }

  /** PUT /internal-api/banneritem */
  update(body: UpdateBannerItemDto): Observable<BannerItem> {
    return this.http.put<BannerItem>(this.apiUrl, body);
  }

  /** DELETE /internal-api/banneritem/{id} */
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
